
export default [
	{
		path: "",
		name: "administratorDashboard",
		component: () => import("../pages/administratorDashboard.vue"),
	},
];
